export function isPositiveInteger (value)
{
	return value.match(/^\d+$/g);
}